import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import colors from "../Constant/colors";

const TransportationManagement = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const cardStyle = {
    background: "#ffffff", // white background
    padding: "20px",
    borderRadius: "14px",
    boxShadow: `0 4px 12px ${colors.cardShadow}`,
    display: "flex",
    alignItems: "center",
    gap: "12px",
    minHeight: "100px",
    transition: "0.3s",
  };

  const heading = {
    fontSize: "18px",
    fontWeight: "600",
    color: colors.grayDark,
  };

  const subText = {
    fontSize: "12px", // updated
    color: colors.grayDark,
    opacity: 0.85,
    marginTop: "2px",
  };

  const iconStyle = {
    fontSize: "32px",
    minWidth: "40px",
  };

  const titleStyle = {
    fontWeight: "700",
    color: colors.grayDark,
  };

  return (
    <div
      style={{ background: "#ffffff", minHeight: "100vh" }}
      className="flex justify-center items-start p-6"
    >
      <div className="w-full max-w-7xl">


        {/* Grid */}
        <div className={`grid gap-6 ${isMobile ? "grid-cols-1" : "grid-cols-3"}`} style={{ alignItems: "stretch" }}>

          {/* Bus Routes */}
          <Link to="/bus-routes" className="flex">
            <div style={cardStyle} className="hover:scale-[1.02] w-full">
              <i className="fas fa-route" style={{ ...iconStyle, color: "#3B82F6" }}></i>
              <div>
                <h2 style={heading}>Bus Routes</h2>
                <p style={subText}>Assign routes of buses.</p>
              </div>
            </div>
          </Link>

          {/* Bus Charges */}
          <Link to="/bus-location" className="flex">
            <div style={cardStyle} className="hover:scale-[1.02] w-full">
              <i className="fas fa-map-marker-alt" style={{ ...iconStyle, color: "#F97316" }}></i>
              <div>
                <h2 style={heading}>Bus Charges</h2>
                <p style={subText}>Assign charges according to routes/locations.</p>
              </div>
            </div>
          </Link>

          {/* Manage Bus */}
          <Link to="/manage-bus" className="flex">
            <div style={cardStyle} className="hover:scale-[1.02] w-full">
              <i className="fas fa-bus" style={{ ...iconStyle, color: "#10B981" }}></i>
              <div>
                <h2 style={heading}>Manage Bus</h2>
                <p style={subText}>Manage school buses and reports.</p>
              </div>
            </div>
          </Link>

          {/* Bus Schedule */}
          <Link to="/bus-schedule" className="flex">
            <div style={cardStyle} className="hover:scale-[1.02] w-full">
              <i className="fas fa-calendar-alt" style={{ ...iconStyle, color: "#8B5CF6" }}></i>
              <div>
                <h2 style={heading}>Bus Schedule</h2>
                <p style={subText}>Track bus schedules and maintenance.</p>
              </div>
            </div>
          </Link>

          {/* Allocate Students */}
          <Link to="/allocate-student" className="flex">
            <div style={cardStyle} className="hover:scale-[1.02] w-full">
              <i className="fas fa-user-plus" style={{ ...iconStyle, color: "#EF4444" }}></i>
              <div>
                <h2 style={heading}>Allocate Students to Bus</h2>
                <p style={subText}>Assign students to their respective buses.</p>
              </div>
            </div>
          </Link>

        </div>
      </div>
    </div>
  );
};

export default TransportationManagement;
